import { createAuthClient } from 'better-auth/react';
import { adminClient } from 'better-auth/client/plugins';

// Same-origin: dev via Vite proxy, prod via CF Pages Functions proxy
// (apps/dashboard/functions/_lib.ts, reads API_ORIGIN). No baseURL.
// adminClient() mirrors the server's admin() plugin (apps/api/src/lib/auth.ts) — adds
// authClient.admin.{impersonateUser,stopImpersonating,...} used by the /admin UI (Task 3).
export const authClient = createAuthClient({ plugins: [adminClient()] });
export const { useSession } = authClient;
